module.exports = __webpack_public_path__ + "assets/ada6ec0551cd1c211698fba023690d71.mp3";